import { FormatsActions } from '../const/ActionsConst';
import { createReducer } from '@common/utils/redux';

const initialState = {
    list: []
};

export default createReducer(
    initialState,
    {
        [FormatsActions.SAVE_FOLDER_FORMATS]: (state, list) => ({
            ...state,
            folderFormats: Array.isArray(list) ? list : []
        }),
        [FormatsActions.CLEAR_FOLDER_FORMATS]: (state) => ({
            ...state,
            folderFormats: []
        }),
    }
);